import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { type DiagramToothAndBridgeListViewItem } from '@modules/rx-intuitive-teeth-orchestrator/models';
import { formatBridgeSpanDisplayFromResolvedNumbers } from '@modules/rx-intuitive-teeth-orchestrator/utils/format-bridge-span-display';
import { RxIntuitiveTreatmentViewlistItemBaseComponent } from '../rx-intuitive-treatment-viewlist-item-base/rx-intuitive-treatment-viewlist-item-base.component';

@Component({
	selector: 'rx-intuitive-bridge-treatment-viewlist-item',
	templateUrl: './rx-intuitive-bridge-treatment-viewlist-item.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RxIntuitiveTreatmentViewlistItemBaseComponent]
})
export class RxIntuitiveBridgeTreatmentViewlistItemComponent {
	@Input() item!: DiagramToothAndBridgeListViewItem;

	get bridgeSpanDisplay(): string {
		return formatBridgeSpanDisplayFromResolvedNumbers(
			this.item.startToothNumberInSystem,
			this.item.endToothNumberInSystem ?? this.item.startToothNumberInSystem
		);
	}
}
